<template>
  <div style="width: 100%;height: 100%">
    <div style="background-color: #fff;">
      <el-tabs
        v-model="editableTabsValue"
        type="card"
        @tab-click="tabClick"
        @tab-remove="tabRemove">
        <el-tab-pane
          v-for="item in editableTabs"
          :closable="item.close"
          :key="item.name"
          :label="item.title"
          :name="item.name">
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navTab',
  data () {
    return {
      editableTabs: [],
      editableTabsValue: '',
      preEditableTabsValue: ''
    }
  },
  created () {
    this.refreshTabs()
  },
  watch: {
    '$store.state.tab.editableTabs': {
      handler: function () {
        this.refreshTabs()
      }
    },
    '$store.state.tab.editableTabsValue': {
      handler: function () {
        this.refreshTabs()
      }
    }
  },
  methods: {
    refreshTabs () {
      // console.log("refresh");
      this.editableTabsValue = this.$store.state.tab.editableTabsValue
      this.editableTabs = this.$store.state.tab.editableTabs
      this.preEditableTabsValue = this.editableTabsValue
    },
    tabClick (tab) {
      let name = JSON.stringify(tab.paneName).replace('"', '').replace('"', '') // 对tab参数处理，以获得当前点击的标签页的路由
      if (name !== this.preEditableTabsValue) {
        this.$store.commit('change_tabs', name) // 调用切换方法切换标签页
        this.$router.push(name) // 路由跳转以实现切换界面
      }
    },
    tabRemove (targetName) {
      let tabs = this.editableTabs
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
        this.$store.state.tab.editableTabsValue = activeName
        this.$store.state.tab.editableTabs = tabs.filter(tab => tab.name !== targetName)
        this.$router.push(activeName)
      } else {
        this.$store.state.tab.editableTabsValue = activeName
        this.$store.state.tab.editableTabs = tabs.filter(tab => tab.name !== targetName)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/home/navTab.vue